import React from "react";

import cx from "classnames";

import Checkbox from "~/ui/legacy/Checkbox";

import type { RadioButtonProps, RadioGroupProps } from "./RadioInput";

import stylesRadioInput from "~/feedback/FormInputs/css/RadioInput.module.css";

import styles from "./css/CheckboxInput.module.css";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isCheckboxValue(value: any): value is string[] {
	return Array.isArray(value) && value.every(item => typeof item === "string");
}

export type CheckboxButtonProps<T extends string> = Omit<RadioButtonProps<T>, "selectedValue" | "onChange"> & {
	checked: boolean;
};

function CheckboxButton<T extends string>({
	label,
	name,
	disabled,
	readonly,
	handleChange,
	checked,
	value,
	className,
}: CheckboxButtonProps<T>) {
	return (
		<label className={cx(stylesRadioInput.radioItem, className)}>
			<Checkbox
				green
				name={name}
				disabled={disabled}
				value={value}
				checked={checked}
				onChange={handleChange}
				readOnly={readonly}
				className={cx({ [styles.readonly]: readonly })}
			/>
			<div className={stylesRadioInput.radioItemContent}>{label}</div>
		</label>
	);
}

export type CheckboxGroupProps<T extends string> = Omit<RadioGroupProps<T>, "value"> & { value: T[] | undefined };

export default function CheckboxInput<T extends string>({
	className,
	options,
	onChange,
	readonly,
	...props
}: CheckboxGroupProps<T>) {
	const handleChange = React.useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value as T;
			if (!readonly) onChange?.(value);
		},
		[readonly, onChange],
	);

	return (
		<div className={className}>
			{options.map(({ value, label }) => (
				<CheckboxButton
					key={value}
					name={props.name}
					handleChange={handleChange}
					checked={props.value?.includes(value) ?? false}
					label={label}
					value={value}
					readonly={!!readonly}
					disabled={!!props.disabled}
				/>
			))}
		</div>
	);
}
